// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventAlertPositive_main-component__grlHL"};